<div class="corepages">

  <!-- <mat-card class="group-listing-table" *ngIf="showGridListing==true">
    <app-group-listing-table
    [displayedColumns]="displayedColumns"
    [dataSources1]="_returnList1"
    [targetList]="coreFieldList"
    [modulename]="Module"
    (showView)=OnShowView($event)>
    </app-group-listing-table>
  </mat-card > -->
  
  <div class="zui-wrapper">
    <app-Listingtable [allids]="Allids" [statusColorList]="statusColorList" [targetList]="coreFieldList" [dataSources]="_returnList"
      [filterList]="coreFilterNameList" [FieldColumnToogle]="coreFieldColumnToogle" [modulename]="Module"
      [showPaycheck]="showPaycheck" [showPCC]="showPCC" [Filtername]="Filtername" [displayedColumns]="displayedColumns"
      [totalCount]="paginatorTotalLength" [pageIndex]="pageIndex" [pageSize]="pageSize"
      (pageChangeEvent)=CallNextPrevPageData($event) (dropListDropped)="dropListDropped($event)"
      (serachRecord)=SearchRecord($event) (filterNameClick)=OnFilterNameClick($event)
      (selectedRecordForAddFavorite)=FavoriteSelectedRecordAddForCore($event)
      (selectedRecordForDeleteFavorite)=FavoriteSelectedRecordForDeleteCore($event)
      (selectedRecordDelete)=DeleteSelectedRecordForCore($event)
      (selectedRecordSendtoPaychex)=SendtoPaychexRecordForCore($event)
      (selectedRecordSendtoPendingPatientPCC)=SendtoPendingPatientPCCRecordForCore($event)
      (selectedCustColumn)=onSubmitColumns($event) (addFilterEvent)=getapplyFilter($event)
      (showRightSideDetails)=getapplyFilter($event) (showRightSidePanel)=getshowRightSidePanel($event)
      (selectedTransactionId)=getselectedTransactionId($event) (addNewRecord)=addNew($event)
      (addFavoriteForFilter)=AddFavoriteForFilter($event) (deleteFavoriteForFilter)=DeleteFavoriteForFilter($event)
      (removeSelectedFilter)=RemoveSelectedFilter($event) (startBroadCasting)=GetRelationsForBroadcast($event,broadCast)
      [isAnyRecordAvailable]="isAnyRecordAvailable" (CheckBoxClearExport)=GetExport($event)
      (selectedRecordArchive)=ArchiveSelectedRecordForCore($event)
      (selectedRecordActivate)=ActivateSelectedRecordForCore($event) (ArchivedFilterEvent)=ShowArchivedFilter()
      (SendtoAttachToTaskList)=CloseAttachToTaskList() >
    </app-Listingtable>
  </div>


</div>


<app-filter *ngIf="showFilter" [filterBindList]="selectedfilterList"
  [sendFromCoreFiltredName]="SendFilteredNameFromCore" (sendFilteredValue)=FilteredList($event)
  [ngClass]="{ open: showFilter  }" (closeFilter)=getCloseFilter($event)
  (closeFilterAfterSave)=getCloseFilterAfterSave($event) (clearApplyFilter)=clearAllApplyFilter($event)>
</app-filter>

<app-listing-detail *ngIf="showDetail" [transactionId]="selectedtransactionId" [ngClass]="{ open: showDetail  }"
  (closeDetail)=getCloseDetail($event)>
</app-listing-detail>

<app-add-listing *ngIf="addListing" (closeAdd)="getClose($event)" [ngClass]="{'open': addListing}">
</app-add-listing>



<!-- <app-attachToTaskList *ngIf="showAttachToTaskList"
[ngClass]="{ open: showAttachToTaskList }"
[folderID]="folderID"
[modulename]="Module"
[mainModulename]="mainModuleName">
</app-attachToTaskList> -->

<ng-template #broadCast>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>podcasts</mat-icon>
    </span>
    Broadcast Message
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="">
      <div class="broadSection">
        <p>Note: Broadcast Your Message Through Text Or Email </p>
        <div class="broadSelected">
          <span *ngIf="!isChecked">Text Message</span>
          <span *ngIf="isChecked">Email</span>
          <mat-slide-toggle [(ngModel)]="isChecked" color="primary"></mat-slide-toggle>
        </div>
      </div>

      <br>
      <div class="broadSection">
        <mat-checkbox (change)="SelectedCore($event)">Send to Selected {{Module}}</mat-checkbox>
      </div>

     <div *ngIf="isChecked">
      <div *ngIf="disabledEmailNotification == true" style="color: red;">
        To enable the Email Action feature, configure your custom SMTP settings in the Admin section. Navigate to the Organization tab, then select Mail to enter the required SMTP details.
      </div>
    </div>

      <mat-form-field appearance="" class="mt-10" appearance="">
        <mat-label>Select Relation</mat-label>
        <mat-select multiple [(value)]="selected">
          <mat-option *ngFor="let coreRelation of coreRelationsList" [value]="coreRelation.coreContractIds">
            {{ coreRelation.transactionalRelationName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Add Subject</mat-label>

        <!-- <input matInput placeholder="Write Subject" [(ngModel)]="subject"> -->

        <input matInput placeholder="Add or select subject" aria-label="State" [matAutocomplete]="auto"
          (input)="searchSubject($event.target.value)" [formControl]="stateCtrl" [(ngModel)]="subject"
          (keydown.enter)="onEnterSubject($event,'')">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="subjectSelected(subject)" *ngFor="let subject of subjectList" [value]="subject.subject">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="info">
                <p> {{ subject.subject }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>

      <mat-form-field appearance="" *ngIf="!isChecked">
        <mat-label>Message</mat-label>
        <textarea maxlength="160" matInput placeholder="Add your broadcast message here..." [(ngModel)]="msg"
          (input)="CheckMessage($event.target.value)" style="min-height: 120px;"></textarea>
      </mat-form-field>
      <div *ngIf="isChecked">
        <mat-label>Message</mat-label>
        <ng-container>
          <ckeditor (change)="CheckMessage($event)" [(ngModel)]="msg" [config]="editorConfig"
            editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js"></ckeditor>
        </ng-container>
      </div>
    </div>



    <button mat-button color="primary" *ngIf="ShowSubjectMessageButton" (click)="AddSubjectMessageTemplate()"
      [disabled]="SubjectMessageButton">Add Template
      <mat-icon *ngIf="spinner">
        <mat-spinner diameter="20">
        </mat-spinner>
      </mat-icon>
    </button>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="closebroadcast()">Cancel</button>
    <button *ngIf="!isChecked" mat-flat-button color="primary" (click)="broadcastMsg()">Send</button>
    <button *ngIf="isChecked" [disabled]="disabledEmailNotification == true" mat-flat-button color="primary" (click)="broadcastMsg()">Send</button>
  </mat-dialog-actions>
</ng-template>

<style>
  .cke_notifications_area { display: none;}
</style>


<style>
  .cke_notification { display: none; }
</style>
<style>
  .cke_notification_warning { display: none; }
</style>